<template>
    <div>
        <div v-if="loading">
            <LiveLogoLoading />
        </div>
        <div class="shop-categories bg-light" v-else>
            <Navbar />
            <Slider />
            <FaqList :faqs="faqs" />
            <div class="container">
                <div class="row">
                    <form @submit="onSubmit" id="GetQuestionForm" class="mt-5 mb-5 text-right d-block">
                        <div class="col-12 float-left">
                            <strong>پاسخی برای سوال خود نیافتید؟</strong>
                            <p>سوال خود را برای ما ارسال نمایید در اولین فرصت با شما تماس خواهیم گرفت.</p>
                        </div>
                        <div class="col-12 float-left">
                            <b-form-group :label="$t('param.fullName')">
                                <b-form-input type="text"
                                              id="fullName"
                                              :data-label="$t('param.fullName')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="fullName"
                                              data-validations='["required"]'></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('param.mobile')">
                                <b-form-input type="text"
                                              id="mobile"
                                              :data-label="$t('param.mobile')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="mobile"
                                              data-validations='["required","mobile"]'></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('param.question')">
                                <b-form-textarea id="question"
                                                 rows="8"
                                                 :data-label="$t('param.question')"
                                                 class="form-control"
                                                 v-model="question"
                                                 data-validations='["required"]'></b-form-textarea>
                            </b-form-group>
                            <p class="alert alert-warning flo mt-2 errors" v-if="warnings.length">
                                <label></label>
                                <ul>
                                    <li v-for="warning in warnings">
                                        {{ $t(warning.type,{label:warning.label}) }}
                                    </li>
                                </ul>
                            </p>
                            <p class="alert alert-danger mt-2 errors" v-if="errors.length">
                                <label></label>
                                <ul>
                                    <li v-for="error in errors">
                                        {{ $t(error.type) }}
                                    </li>
                                </ul>
                            </p>
                            <div class="col-12 mt-2 pr-0 pl-0 float-right">
                                <button class="btn btn-block btn-dark mt-2" type="submit" v-bind:disabled="formLoading">
                                    <span v-if="!formLoading">ارسال سوال</span>
                                    <span v-if="formLoading" class="spinner-border spinner-border-sm"></span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    </div>
</template>
<script>
    import LiveLogoLoading from "@/components/LiveLogoLoading";
    import Slider from "./Faq/Slider";
    import FaqList from "./Faq/FaqList";
    import Navbar from "./share/Navbar";
    import Footer from "./share/Footer";

    import "jquery/src/jquery.js";
    import "bootstrap/dist/js/bootstrap.min.js";


    import utility from '@/plugins/utility';
    const form = new utility.form('#GetQuestionForm');

    export default {
        components: {
            LiveLogoLoading,
            FaqList,
            Slider,
            Navbar,
            Footer
        },

        data()
        {
            return {
                loading: true,
                formLoading: false,
                fullName: '',
                mobile: '',
                question: '',
                warnings: [],
                errors: [],
                faqs: []
            };
        },

        beforeMount()
        {
            this.initShops();
        },

        methods: {
            initShops()
            {
                axios({ method: "get", url: "/api/General/GetFaqs" })
                    .then(response =>
                    {
                        this.faqs = response.data.faqs;
                        this.loading = false;
                    })
                    .catch(error => { });
            },

            onSubmit(evt)
            {
                evt.preventDefault()
                this.warnings = form.errors();
                this.errors = [];

                this.formLoading = true;

                if (this.warnings.length == 0)
                {
                    axios({
                        method: 'post',
                        url: '/api/General/SaveQuestion',
                        data: {
                            FullName: this.fullName,
                            Mobile: this.mobile,
                            Question: this.question
                        }
                    })
                        .then(response =>
                        {
                            this.formLoading = false;
                            if (response.data.success)
                            {
                                this.$bvToast.toast('سوال شما با موفقیت ثبت شد، همکاران ما به زودی با شما تماس خواهند گرفت.', {
                                    title: 'عملیات موفق',
                                    toaster: 'b-toaster-top-center',
                                    variant: 'success',
                                    bodyClass: 'text-center',
                                    noCloseButton: true,
                                    solid: true
                                })

                                this.fullName = ""
                                this.mobile = ""
                                this.question = ""
                            }
                        })
                        .catch(error =>
                        {
                            this.errors = [{ type: 'errors.server' }];
                            this.formLoading = false;
                        });
                }
            }
        }
    };
</script>
<style scoped>
    form{
        direction:rtl;
    }
</style>
